import { useContext } from 'react';

import { TimeseriesXAxisConfigContext } from '../context/TimeseriesXAxisConfig.context.js';

export const useXAxisConfig = () => useContext(TimeseriesXAxisConfigContext);
